import { connect } from 'react-redux';
import { setState } from '@jvitela/recompute';
import Select from '../../state/Select';
import Action from '../../state/Action';

var mapStateToProps = function mapStateToProps(state, ownProps) {
  setState(state);
  return Select.data.components.getDataForCartesianChart(ownProps);
};

var mapDispatchToPropsFactory = function mapDispatchToPropsFactory() {
  return function (dispatch, ownProps) {
    return {
      onMount: function onMount() {
        dispatch(Action.data.components.use(ownProps.stateComponentKey));
      },
      onUnmount: function onUnmount() {
        dispatch(Action.data.components.componentUseClear(ownProps.stateComponentKey));
      }
    };
  };
};

export default connect(mapStateToProps, mapDispatchToPropsFactory);